import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { useAdminAuth } from "@/context/AdminAuth";
import { apiErr } from "@/lib/api";
import { BrandMark } from "@/components/BrandMark";
import { ArrowRight } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAdminAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("admin@societyos.in");
  const [password, setPassword] = useState("Admin@123");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      navigate("/admin");
    } catch (err) {
      toast.error(apiErr(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-sand-50 flex flex-col">
      <div className="max-w-7xl mx-auto w-full px-6 lg:px-10 py-6">
        <Link to="/"><BrandMark variant="portal" size={44} /></Link>
      </div>
      <div className="flex-1 flex items-center justify-center px-6">
        <div className="w-full max-w-md bg-white border border-stone-200 rounded-2xl p-10">
          <div className="text-xs uppercase tracking-widest text-stone-500 font-semibold mb-3">Platform staff</div>
          <h1 className="editorial text-3xl leading-tight mb-2">Sign in to Portal Owner</h1>
          <p className="text-stone-600 mb-8 text-sm">Only for SocietyOS team members. Society residents log in via their society&apos;s OTP page.</p>
          <form onSubmit={submit} className="space-y-4" data-testid="admin-login-form">
            <div>
              <label className="text-xs uppercase tracking-widest text-stone-500 font-semibold">Email</label>
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
                data-testid="admin-email"
                className="mt-2 w-full rounded-xl border border-stone-300 bg-white px-4 py-3 text-base focus:border-terracotta focus:ring-2 focus:ring-terracotta/20 outline-none" />
            </div>
            <div>
              <label className="text-xs uppercase tracking-widest text-stone-500 font-semibold">Password</label>
              <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
                data-testid="admin-password"
                className="mt-2 w-full rounded-xl border border-stone-300 bg-white px-4 py-3 text-base focus:border-terracotta focus:ring-2 focus:ring-terracotta/20 outline-none" />
            </div>
            <button type="submit" disabled={busy} data-testid="admin-login-submit"
              className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-terracotta hover:bg-terracotta-hover disabled:opacity-50 text-white px-6 py-3.5 text-base font-medium transition-colors">
              {busy ? "Signing in…" : "Sign in"} <ArrowRight size={18} />
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
